export default "__VITE_ASSET__67fd89fe__"